// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --icon-valid: url(/assets/icons/i-valid.svg);
  --icon-invalid: url(/assets/icons/i-invalid.svg);
}

.basic-info {
  font: 14px/17px "Roboto-Bold";
  padding: 9px 0 19px;
}
.basic-info .name {
  text-transform: uppercase;
  color: rgb(44, 52, 60);
  padding: 0 0 5px;
}
.basic-info .rut {
  font: 18px/21px "Roboto-Regular";
  color: rgb(96, 112, 129);
  padding: 0 0 5px;
}
.basic-info .age {
  font-weight: bold;
  font-size: 14px;
}
.basic-info .contact-info {
  margin-top: 2px;
  font: 14px/17px "Roboto-Regular";
}

.divider {
  padding: 0 0 16px;
}
.divider.vertical {
  padding: 0 30px;
}
@media (max-width: 720px) {
  .divider.vertical {
    display: none;
  }
}

.value {
  font: 14px "Roboto-Regular";
  color: rgb(96, 112, 129);
}

.attribute {
  font: 14px "Roboto-Bold";
  color: rgb(194, 27, 23);
}

.icon {
  overflow: visible;
  width: 17px;
  height: 17px;
  margin-right: 5px;
}

.icon-contacted {
  display: flex;
  background-size: contain;
  width: 42px;
  height: 35px;
  margin: 0 0 5px 5px;
}

.row {
  display: flex;
  align-content: center;
  align-items: center;
  margin-top: 10px;
}
.row.location {
  margin-top: 0;
  padding: 0 0 5px;
}
.row.space-between {
  justify-content: space-between;
}

.details {
  margin-top: 10px;
}
@media (min-width: 720px) {
  .details {
    display: flex;
    justify-content: space-between;
  }
}
.details .details-list {
  padding: 0 0 29px;
  min-width: 300px;
}
.details .products-grid {
  display: grid;
  max-width: 350px;
  margin-top: 10px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 5px;
  padding: 0 0 10px;
}
@media (min-width: 720px) {
  .details .products-grid {
    height: -moz-fit-content;
    height: fit-content;
  }
}
.details .products-grid .header {
  padding: 0 0 10px;
}
.details .products-grid .right {
  grid-column: span 3;
}
.details .products-grid .right .portfolio-fund {
  margin-right: 15px;
  padding-left: 4px;
  border-left: 3px solid;
}
.details .products-grid .right .portfolio-fund.fund-a {
  border-color: rgb(186, 78, 79);
}
.details .products-grid .right .portfolio-fund.fund-b {
  border-color: rgb(243, 174, 2);
}
.details .products-grid .right .portfolio-fund.fund-c {
  border-color: rgb(106, 161, 90);
}
.details .products-grid .right .portfolio-fund.fund-d {
  border-color: rgb(100, 158, 178);
}
.details .products-grid .right .portfolio-fund.fund-e {
  border-color: rgb(72, 126, 239);
}

.contact-info-biotablet {
  padding: 0 0 23px;
}
.contact-info-biotablet .section {
  display: flex;
  align-items: center;
  width: 50%;
}
.contact-info-biotablet .section .info {
  display: flex;
  flex-direction: column;
}

.horizontal-buttons,
.vertical-buttons {
  z-index: 1;
  position: fixed;
  bottom: 255px;
  right: 9px;
  display: flex;
  gap: 16px;
  align-items: center;
  flex-direction: column;
  width: 60px;
}
.horizontal-buttons .btn-rounded-floating,
.vertical-buttons .btn-rounded-floating {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  border-radius: 30px;
  height: 60px;
  max-width: 60px;
  background-color: #EA6852;
  box-shadow: 0px 2px 4px rgba(96, 112, 129, 0.2), 0px 6px 16px rgba(96, 112, 129, 0.3);
}
.horizontal-buttons .btn,
.vertical-buttons .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  justify-items: center;
}
.horizontal-buttons .btn-large,
.vertical-buttons .btn-large {
  min-width: 0;
  margin: 0 0;
}
.horizontal-buttons .icon-container,
.vertical-buttons .icon-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.horizontal-buttons .icon-container .icon,
.vertical-buttons .icon-container .icon {
  overflow: visible;
  margin: 0 1px 0 0;
  background-size: 17.1px 17.1px;
}
.horizontal-buttons .wsp,
.vertical-buttons .wsp {
  color: rgb(6, 194, 112);
  border-color: white;
  background-color: white;
}
.horizontal-buttons .wsp:hover,
.vertical-buttons .wsp:hover {
  background-color: rgba(6, 194, 112, 0.2);
}
.horizontal-buttons .email,
.vertical-buttons .email {
  color: rgb(6, 194, 112);
  border-color: white;
  background-color: white;
}
.horizontal-buttons .email:hover,
.vertical-buttons .email:hover {
  background-color: rgba(6, 194, 112, 0.2);
}

.horizontal-buttons {
  display: flex;
  flex-direction: row;
  width: auto;
  position: unset;
  margin-left: auto;
}
.horizontal-buttons .icon-container .icon {
  width: 25px;
  height: 25px;
  background-size: 25px;
}

.comments {
  width: 100%;
}

.box-field {
  margin: 10px 0 25px;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 0px 1px rgba(96, 112, 129, 0.2), 0px 1px 4px rgba(96, 112, 129, 0.3);
  background-color: rgb(255, 255, 255);
}

.third-section,
.fourth-section {
  display: flex;
  max-width: 775px;
  justify-content: space-between;
}

.contact-info-biodesktop,
.complains {
  width: 350px;
  padding: 0 0 4rem;
}
.contact-info-biodesktop .header,
.complains .header {
  font: 14px "Roboto-Bold";
  color: rgb(194, 27, 23);
}
.contact-info-biodesktop .no-tickets,
.complains .no-tickets {
  margin-top: 23px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #B0B2B3;
  padding: 0px 50px;
}
.contact-info-biodesktop .ticket-card,
.complains .ticket-card {
  margin-top: 16px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
}
.contact-info-biodesktop .ticket-card .col-left,
.complains .ticket-card .col-left {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.contact-info-biodesktop .ticket-card .col-left .ticket,
.complains .ticket-card .col-left .ticket {
  font-family: "Roboto-Bold";
  font-size: 12px;
  line-height: 20px;
  color: #6F7072;
  padding: 14px 0 0 18px;
}
.contact-info-biodesktop .ticket-card .col-left .date,
.complains .ticket-card .col-left .date {
  font-size: 12px;
  line-height: 20px;
  color: #607081;
  padding: 5px 0 14px 18px;
}
.contact-info-biodesktop .complain-ticket,
.complains .complain-ticket {
  width: 100%;
}
.contact-info-biodesktop .icon,
.complains .icon {
  display: block;
}

.text {
  font: 14px "Roboto-Bold";
}
.text.primary {
  color: rgb(61, 145, 94);
}
.text.secondary {
  color: rgb(66, 66, 67);
}

.contacted-container {
  text-align: -webkit-center;
}
.contacted-container.mobile {
  position: absolute;
  right: 3%;
  top: 33px;
}

.contact-link {
  z-index: 1;
  font: 14px/16px "Roboto-Regular";
  color: rgb(194, 27, 23);
  text-decoration-line: underline;
  cursor: pointer;
}
@media (max-width: 720px) {
  .contact-link {
    position: fixed;
    bottom: -5px;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 30px;
    margin: 0 -30px;
    padding: 15px 0 0;
    white-space: pre;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: rgb(255, 255, 255);
    box-shadow: 0px 2px 8px rgba(96, 112, 129, 0.2), 0px 15px 32px rgba(96, 112, 129, 0.3);
  }
}

.desktop-container .first-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 20px;
}
.desktop-container .first-section .contact-status-container {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 65%;
}
.desktop-container .first-section .title {
  font: 14px/16px "Roboto-Bold";
  color: rgb(66, 66, 67);
  margin-right: 20px;
}
@media (max-width: 720px) {
  .desktop-container .first-section .title {
    display: none;
  }
}
.desktop-container .first-section .contact-link {
  margin: 0 20px;
}
@media (max-width: 720px) {
  .desktop-container .first-section .contact-link {
    margin: 0 -30px;
  }
}

.comments-desktop {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 15px;
}
.comments-desktop .comments {
  width: 50%;
}

.mat-mdc-form-field .mat-mdc-input-element {
  font: 12px "Roboto-Regular";
  height: 100px;
}
@media (max-width: 720px) {
  .mat-mdc-form-field .mat-mdc-input-element {
    height: 65px;
  }
}

::ng-deep .mat-mdc-form-field-flex {
  padding: 0 0.75em 0 0.75em;
}
::ng-deep .mdc-notched-outline {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/modules/post-venta/my-portfolio/portfolio-affiliate-detail/portfolio-affiliate-detail.component.scss"],"names":[],"mappings":"AAoHA;EACE,4CAAA;EACA,gDAAA;ACnHF;;AADA;EACE,6BAAA;EACA,mBAAA;AAIF;AAFE;EACE,yBAAA;EACA,sBD+DY;EC9DZ,gBAAA;AAIJ;AADE;EACE,gCAAA;EACA,wBDwDY;ECvDZ,gBAAA;AAGJ;AAAE;EACE,iBAAA;EACA,eAAA;AAEJ;AACE;EACE,eAAA;EACA,gCAAA;AACJ;;AAGA;EACE,iBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAEI;EAHF;IAII,aAAA;EACJ;AACF;;AAGA;EACE,2BAAA;EACA,wBD2Bc;AC3BhB;;AAGA;EACE,wBAAA;EACA,uBD3CY;AC2Cd;;AAGA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,gBAAA;AAAJ;AAGE;EACE,8BAAA;AADJ;;AAKA;EACE,gBAAA;AAFF;AAIE;EAHF;IAII,aAAA;IACA,8BAAA;EADF;AACF;AAGE;EACE,iBAAA;EACA,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;AAII;EAVF;IAWI,wBAAA;IAAA,mBAAA;EADJ;AACF;AAGI;EACE,iBAAA;AADN;AAKI;EACE,mBAAA;AAHN;AAKM;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;AAHR;AAKQ;EACE,8BDhFD;AC6ET;AAMQ;EACE,8BDnFD;AC+ET;AAOQ;EACE,+BDtFD;ACiFT;AAQQ;EACE,gCDzFD;ACmFT;AASQ;EACE,+BD5FD;ACqFT;;AAcA;EACE,iBAAA;AAXF;AAaE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAXJ;AAaI;EACE,aAAA;EACA,sBAAA;AAXN;;AAgBA;;EAEE,UAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EAEA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AAdF;AAgBE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qFAAA;AAbJ;AAgBE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AAbJ;AAgBE;;EACE,YAAA;EACA,WAAA;AAbJ;AAgBE;;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAbJ;AAeI;;EACE,iBAAA;EACA,iBAAA;EACA,8BAAA;AAZN;AAiBE;;EACE,uBD3IuB;EC4IvB,mBAAA;EACA,uBAAA;AAdJ;AAgBI;;EACE,wCD/I2B;ACkIjC;AAiBE;;EACE,uBDrJuB;ECsJvB,mBAAA;EACA,uBAAA;AAdJ;AAgBI;;EACE,wCDzJ2B;AC4IjC;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAhBF;AAmBI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAjBN;;AAsBA;EACE,WAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,oFD/Ja;ECgKb,oCDxIM;ACqHR;;AAsBA;;EAEE,aAAA;EACA,gBAAA;EACA,8BAAA;AAnBF;;AAsBA;;EAEE,YAAA;EACA,iBAAA;AAnBF;AAqBE;;EACE,wBAAA;EACA,uBDlRU;ACgQd;AAqBE;;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAlBJ;AAqBE;;EACE,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;AAlBJ;AAoBI;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAjBN;AAmBM;;EACE,0BD7JI;EC8JJ,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAhBR;AAmBM;;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;AAhBR;AAqBE;;EACE,WAAA;AAlBJ;AAqBE;;EACE,cAAA;AAlBJ;;AAsBA;EACE,wBAAA;AAnBF;AAqBE;EACE,uBDtSQ;ACmRZ;AAsBE;EACE,sBD7UY;ACyThB;;AAwBA;EACE,0BAAA;AArBF;AAuBE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AArBJ;;AAyBA;EACE,UAAA;EACA,gCAAA;EACA,uBD5VY;EC6VZ,+BAAA;EACA,eAAA;AAtBF;AAwBE;EAPF;IAQI,eAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IAEA,4BAAA;IACA,6BAAA;IACA,8BDpPI;ICqPJ,sFD5QW;ECsPb;AACF;;AA0BE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,oBAAA;AAvBJ;AAyBI;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,UAAA;AAvBN;AA0BI;EACE,6BAAA;EACA,sBDpYU;ECqYV,kBAAA;AAxBN;AA0BM;EALF;IAMI,aAAA;EAvBN;AACF;AA0BI;EACE,cAAA;AAxBN;AA0BM;EAHF;IAII,eAAA;EAvBN;AACF;;AA4BA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAzBF;AA0BE;EACE,UAAA;AAxBJ;;AA4BA;EACE,2BAAA;EACA,aAAA;AAzBF;AA0BE;EAHF;IAII,YAAA;EAvBF;AACF;;AA6BE;EACE,0BAAA;AA1BJ;AA6BE;EACE,wBAAA;AA3BJ","sourcesContent":["// ----------------------------- Colors System-----------------------------\n$text-primary: rgb(111, 112, 114);                // #6F7072\n$text-secondary: rgb(52, 52, 52);                 // #343434FF\n$text-tertiary: rgb(66, 66, 67);                  // #424243FF\n$text-graph: rgb(157, 157, 157);                  // #9D9D9DFF\n$red-primary: rgb(194, 27, 23);                   // #C23B33\n$red-secondary: rgb(117, 33, 39);                 // #752127FF\n$red-secondary-light: rgb(238, 144, 123);         // #EE907B\n$red-secondary-dark: rgb(142, 42, 42);            // #8E2A2A\n$red-tertiary: rgb(142, 18, 48);                  // #8E1230FF\n$red-quaternary: rgb(223, 103, 68);               // #DF6744FF\n$red-alt: rgb(224, 146, 141);                     // #E0928DFF\n$red-scrollbar: rgb(239,220,222);                 // #EFDCDEFF\n$red-light: rgb(252, 250, 250);                   // #FCFAFAFF\n$red-lighter: rgb(255, 221, 219);                 // #FFDDDBFF\n$red-lightest: rgb(255, 247, 247);                // #FFF7F7FF\n$red-tomato: rgb(243,98,66);                      // #F36242FF\n$alert-background: rgb(239, 220, 222);            // #EFDCDEFF\n$error-background: rgb(237, 211, 200);            // #EDD3C8FF\n\n$selected-background: rgb(237, 237, 237);         // #EDEDEDFF\n$reason-error-background: rgb(249, 249, 249);     // #F9F9F9FF\n$interaction-btn-background: rgb(255, 245, 244);  // #FFF5F4FF\n\n$dashed-line: rgb(207, 207, 207);                 // #CFCFCFFF\n$shadow: rgb(181, 181, 181);                      // #B5B5B5FF\n$separator: rgb(215, 215, 215);                   // #D7D7D7FF\n$border-color-primary: rgb(151, 151, 151);        // #979797FF\n$color-secondary-contrast-rgba: rgba(255, 255, 255, 0.4); // #FFFFFF66\n$color-medium-rgba: rgba(118,119,122,0.2);        // #76777A33\n$color-medium-tint-rgba: rgba(154,154,154,0.15);\n\n\n$border-color-tertiary: rgb(225, 141, 137);       // #E18D89\n$disabled-color: rgb(214, 219, 225);              // #D6DBE1\n$inactive-color: rgb(160, 160, 160);              // #A0A0A0\n$status-active: rgb(105, 162, 91);                // #69A25BFF\n$status-inactive: $disabled-color;\n$sea-green: rgb(61, 145, 94);                     // #3D915EFF\n$stepper-background: rgb(244, 244, 244);          // #F4F4F4FF\n\n\n// Funds Colors\n$fund-a: rgb(186, 78, 79);                        // #BA4E4FFF\n$fund-b: rgb(243, 174, 2);                        // #F3AE02FF\n$fund-c: rgb(106, 161, 90);                       // #6AA15AFF\n$fund-d: rgb(100, 158, 178);                      // #649EB2FF\n$fund-e: rgb(72, 126, 239);                       // #487EEFFF\n\n$fund-a-light: rgba(186, 78, 79, 0.15);           // #BA4E4F26\n$fund-b-light: rgba(243, 174, 2, 0.15);           // #F3AE0226\n$fund-c-light: rgba(106, 161, 90, 0.15);          // #6AA15A26\n$fund-d-light: rgba(100, 158, 178, 0.15);         // #649EB226\n$fund-e-light: rgba(72, 126, 239, 0.15);          // #487EEF26\n\n// Accounts Colors\n$account-cco: rgb(46, 113, 193);  // CCICO        // #2E71C1FF\n$account-cav: rgb(52, 66, 91);    // CAV          // #34425BFF\n$account-cai: rgb(255, 139, 142); // CAI          // #FF8B8EFF\n$account-ccv: rgb(61, 145, 94);   // CCICV        // #3D915EFF\n$account-cdc: rgb(235, 104, 58);  // CCIDC        // #EB683AFF\n$account-caf: rgb(254, 167, 48);  // CCIAV        // #FEA730FF\n$account-cvc: rgb(97, 73, 170);   // APVC         // #6149AAFF\n\n// Reuses\n$white: white;\n$black: black;\n$text-error: $red-primary;\n\n// New Color System - Figma\n$color-dark-01: rgb(96, 112, 129);               // ##607081\n$color-dark-02: rgb(44, 52, 60);                 // #2C343C\n$color-light-01: rgb(246, 247, 248);             // #F6F7F8\n$color-light-02: rgb(166, 177, 189);             // #A6B1BD\n$color-light-03: rgb(166, 177, 189);             // #A6B1BD\n$color-light-04: rgb(247, 247, 247);             // #F7F7F7\n\n$color-status-success-mid: rgb(6, 194, 112);     // #06C270\n$color-status-success-mid-gamma: rgba(6, 194, 112, 0.2);\n\n// Other\n$red-secondary-degraded: rgb(142, 42, 42);\n$dark-light: rgb(96, 112, 129);\n$grey-mid-dark: rgb(112, 112, 112);               // #707070\n$shadow-lightest: rgba(0, 0, 0, 0.1);\n$collector-color: rgb(238, 93, 100);\n$input-color: rgb(26, 26, 26);\n$red-dark: #930800;\n$transparency: rgba(0, 0, 0, 0.17);\n\n// Profitability colors\n$customer-contribution: rgb(246, 196, 67);         // #F6C443\n$profit: rgb(135, 148, 200);                       // #8794C8\n$withdrawal: rgb(222, 111, 90);                    // #DE6F5A\n\n// Timer colors\n\n$status-alert-mid: rgba(255, 205, 0, 1);\n$status-alert-dark: rgba(117, 98, 1, 1);\n$status-alert-light: rgba(255, 254, 229, 1);\n\n// Elevations\n$elevation-02: 0px 0px 1px rgba(96, 112, 129, 0.2), 0px 1px 4px rgba(96, 112, 129, 0.3);\n$elevation-06: 0px 2px 8px rgba(96, 112, 129, 0.2), 0px 15px 32px rgba(96, 112, 129, 0.3);\n$box-shadow: 0 6px 12px 0 rgba(0,0,0,0.15);\n$box-shadow-04: 0 4px 4px rgba(0,0,0,0.25);\n\n// Gradients\n$header-gradient: linear-gradient(270deg, $red-dark 0%, $red-primary 100%);\n$header-gradient-mobile: linear-gradient(30deg, $red-dark 0%, $red-primary 100%);\n$side-menu-gradient: linear-gradient(238.2deg, $red-primary 0%, #930800 85.46%);\n\n\n\n// ----------------------------- SVG -----------------------------\n\n:root {\n  --icon-valid: url(/assets/icons/i-valid.svg);\n  --icon-invalid: url(/assets/icons/i-invalid.svg);\n}\n\n// Legacy\n\n$turquoise: rgb(61, 142, 145);\n$turquoise-light: rgba(185, 215, 224, 0.3);\n\n$white: rgba(255, 255, 255, 1); // **\n$white-smoke: rgba(239, 239, 239, 0.6); // **\n$white-smoke-transparent: rgba(255, 255, 255, 0.8); // **\n\n$grey-darkest: rgb(51, 51, 51); // **\n$grey-darker: rgb(67, 67, 67); // **\n$grey-dark: rgb(100, 100, 100); // **\n$grey-mid-dark: rgb(107, 107, 107); // **\n$grey: rgb(154, 154, 154);\n$grey-white: rgb(245, 245, 245);\n$grey-white1: #F9F9F9;\n$grey-white2: #EDEDED;\n$grey-white3: #D9D9D9;\n$white-semitransparent: rgba(255, 255, 255, 0.3);\n\n$white-gradient: linear-gradient(180deg, $white 30%, $white-semitransparent 70%);\n\n// Fonts\n$font-regular: \"Roboto-Regular\";\n$font-medium: \"Roboto-Medium\";\n$font-bold: \"Roboto-Bold\";\n\n// Media query\n$break-xs: 360px;\n$break-small-mid: 400px;\n$break-small: 480px;\n$break-medium: 720px;\n$break-large: 795px;\n$break-xlarge-mid: 897px;\n$break-xlarge: 1000px;\n$break-xxlarge-mid: 1220px;\n$break-xxlarge: 1440px;\n$width-mobile: 415px;\n\n// Funds Cards\n$max-width-card: 441px;\n$min-width-card: 300px;\n","@import 'variables.scss';\n\n.basic-info {\n  font: 14px/17px $font-bold;\n  padding: 9px 0 19px;\n\n  .name {\n    text-transform: uppercase;\n    color: $color-dark-02;\n    padding: 0 0 5px;\n  }\n\n  .rut {\n    font: 18px/21px $font-regular;\n    color: $color-dark-01;\n    padding: 0 0 5px;\n  }\n\n  .age {\n    font-weight: bold;\n    font-size: 14px;\n  }\n\n  .contact-info {\n    margin-top: 2px;\n    font: 14px/17px $font-regular;\n  }\n}\n\n.divider {\n  padding: 0 0 16px;\n\n  &.vertical {\n    padding: 0 30px;\n\n    @media (max-width: $break-medium) {\n      display: none;\n    }\n  }\n}\n\n.value {\n  font: 14px $font-regular;\n  color: $color-dark-01;\n}\n\n.attribute {\n  font: 14px $font-bold;\n  color: $red-primary;\n}\n\n.icon {\n  overflow: visible;\n  width: 17px;\n  height: 17px;\n  margin-right: 5px;\n}\n\n.icon-contacted {\n  display: flex;\n  background-size: contain;\n  width: 42px;\n  height: 35px;\n  margin: 0 0 5px 5px;\n}\n\n.row {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  margin-top: 10px;\n\n  &.location {\n    margin-top: 0;\n    padding: 0 0 5px;\n  }\n\n  &.space-between {\n    justify-content: space-between\n  }\n}\n\n.details {\n  margin-top: 10px;\n\n  @media (min-width: $break-medium) {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .details-list {\n    padding: 0 0 29px;\n    min-width: 300px;\n  }\n\n  .products-grid {\n    display: grid;\n    max-width: 350px;\n    margin-top: 10px;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 24px;\n    grid-row-gap: 5px;\n    padding: 0 0 10px;\n\n    @media (min-width: $break-medium) {\n      height: fit-content;\n    }\n\n    .header {\n      padding: 0 0 10px;\n      ;\n    }\n\n    .right {\n      grid-column: span 3;\n\n      .portfolio-fund {\n        margin-right: 15px;\n        padding-left: 4px;\n        border-left: 3px solid;\n\n        &.fund-a {\n          border-color: $fund-a\n        }\n\n        &.fund-b {\n          border-color: $fund-b\n        }\n\n        &.fund-c {\n          border-color: $fund-c\n        }\n\n        &.fund-d {\n          border-color: $fund-d\n        }\n\n        &.fund-e {\n          border-color: $fund-e\n        }\n      }\n    }\n  }\n}\n\n.contact-info-biotablet {\n  padding: 0 0 23px;\n\n  .section {\n    display: flex;\n    align-items: center;\n    width: 50%;\n\n    .info {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n}\n\n.horizontal-buttons,\n.vertical-buttons {\n  z-index: 1;\n  position: fixed;\n  bottom: 255px;\n  right: 9px;\n\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-direction: column;\n  width: 60px;\n\n  .btn-rounded-floating {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    justify-items: center;\n    border-radius: 30px;\n    height: 60px;\n    max-width: 60px;\n    background-color: #EA6852;\n    box-shadow: 0px 2px 4px rgba(96, 112, 129, 0.2), 0px 6px 16px rgba(96, 112, 129, 0.3);\n  }\n\n  .btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    justify-items: center;\n  }\n\n  .btn-large {\n    min-width: 0;\n    margin: 0 0;\n  }\n\n  .icon-container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    justify-items: center;\n\n    .icon {\n      overflow: visible;\n      margin: 0 1px 0 0;\n      background-size: 17.1px 17.1px;\n    }\n\n  }\n\n  .wsp {\n    color: $color-status-success-mid;\n    border-color: #FFFF;\n    background-color: #FFFF;\n\n    &:hover {\n      background-color: $color-status-success-mid-gamma;\n    }\n  }\n\n  .email {\n    color: $color-status-success-mid;\n    border-color: #FFFF;\n    background-color: #FFFF;\n\n    &:hover {\n      background-color: $color-status-success-mid-gamma;\n    }\n  }\n\n}\n\n.horizontal-buttons {\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  position: unset;\n  margin-left: auto;\n\n  .icon-container {\n    .icon {\n      width: 25px;\n      height: 25px;\n      background-size: 25px;\n    }\n  }\n}\n\n.comments {\n  width: 100%;\n}\n\n.box-field {\n  margin: 10px 0 25px;\n  width: 100%;\n  border-radius: 4px;\n  box-shadow: $elevation-02;\n  background-color: $white;\n}\n\n.third-section,\n.fourth-section {\n  display: flex;\n  max-width: 775px;\n  justify-content: space-between;\n}\n\n.contact-info-biodesktop,\n.complains {\n  width: 350px;\n  padding: 0 0 4rem;\n\n  .header {\n    font: 14px $font-bold;\n    color: $red-primary;\n  }\n\n  .no-tickets {\n    margin-top: 23px;\n    font-size: 14px;\n    line-height: 22px;\n    text-align: center;\n    color: #B0B2B3;\n    padding: 0px 50px;\n  }\n\n  .ticket-card {\n    margin-top: 16px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    display: flex;\n\n    .col-left {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n\n      .ticket {\n        font-family: $font-bold;\n        font-size: 12px;\n        line-height: 20px;\n        color: #6F7072;\n        padding: 14px 0 0 18px;\n      }\n\n      .date {\n        font-size: 12px;\n        line-height: 20px;\n        color: #607081;\n        padding: 5px 0 14px 18px;\n      }\n    }\n  }\n\n  .complain-ticket {\n    width: 100%;\n  }\n\n  .icon {\n    display: block;\n  }\n}\n\n.text {\n  font: 14px $font-bold;\n\n  &.primary {\n    color: $sea-green;\n  }\n\n  &.secondary {\n    color: $text-tertiary;\n  }\n}\n\n.contacted-container {\n  text-align: -webkit-center;\n\n  &.mobile {\n    position: absolute;\n    right: 3%;\n    top: 33px;\n  }\n}\n\n.contact-link {\n  z-index: 1;\n  font: 14px/16px $font-regular;\n  color: $red-primary;\n  text-decoration-line: underline;\n  cursor: pointer;\n\n  @media (max-width: $break-medium) {\n    position: fixed;\n    bottom: -5px;\n    display: flex;\n    justify-content: center;\n    width: 100vw;\n    height: 30px;\n    margin: 0 -30px;\n    padding: 15px 0 0;\n    white-space: pre;\n\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    background: $white;\n    box-shadow: $elevation-06;\n  }\n}\n\n.desktop-container {\n  .first-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    padding-bottom: 20px;\n\n    .contact-status-container {\n      display: flex;\n      align-items: baseline;\n      justify-content: space-between;\n      width: 65%;\n    }\n\n    .title {\n      font: 14px/16px $font-bold;\n      color: $text-tertiary;\n      margin-right: 20px;\n\n      @media (max-width: $break-medium) {\n        display: none;\n      }\n    }\n\n    .contact-link {\n      margin: 0 20px;\n\n      @media (max-width: $break-medium) {\n        margin: 0 -30px;\n      }\n    }\n  }\n}\n\n.comments-desktop {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 15px;\n  .comments {\n    width: 50%;\n  }\n}\n\n.mat-mdc-form-field .mat-mdc-input-element {\n  font: 12px $font-regular;\n  height: 100px;\n  @media (max-width: $break-medium) {\n    height: 65px;\n  }\n}\n\n\n::ng-deep {\n\n  .mat-mdc-form-field-flex {\n    padding: 0 .75em 0 .75em;\n  }\n\n  .mdc-notched-outline {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
